export default __webpack_public_path__ + "static/media/Car.f8a3ae9e.svg";